import React, {ReactNode} from "react";
import Icon, {ICON_NAME} from "../../Icon";
import styles from "../style.module.scss";

interface IProps {
    children: string | ReactNode

    onClear(): void
}

const ValueAndClear: React.FC<IProps> = ({children, onClear}) => {
    return <div className={styles.valueAndClear}>
        <div>{children}</div>
        <div data-lev='close' onClick={onClear}>
            <Icon icon={ICON_NAME.CLOSE}/>
        </div>
    </div>;
};

export default ValueAndClear;